import { CollectionProvider } from 'scripts/adapters/stores/lib/collection_store_base';
import createCollectionStoreClass from 'scripts/adapters/stores/lib/create_collection_store_class';
import createConverter from 'scripts/adapters/immutable_converters/lib/create_converter';
import TeamAssistV2Turn from 'models/team_assist_v2_turn';

// Set while a Clear's DELETE hasn't answered: glados still has the session
// being cleared active, so the panel holds new questions until it does.
const CLEARING_PATH = 'clearing';

// Set once a session load has answered, so a panel that appears after the
// customer was loaded (the flag turned on meanwhile) knows to load one. It is
// meta, so removing the customer keeps it: a customer loaded with the flag off
// resets it.
const LOADED_PATH = 'loaded';

class TeamAssistV2TurnsProvider extends CollectionProvider {
  isClearing() {
    return !!this.immutableStore.binding.meta(CLEARING_PATH).get();
  }

  hasLoaded() {
    return !!this.immutableStore.binding.meta(LOADED_PATH).get();
  }

  static create(immutableStore, options) {
    return new TeamAssistV2TurnsProvider(immutableStore, options);
  }
}

export default class TeamAssistV2TurnsStore extends createCollectionStoreClass({
  converter: createConverter(TeamAssistV2Turn),
}) {
  constructor(binding, opts) {
    super(binding, { createProvider: TeamAssistV2TurnsProvider.create, ...opts });
  }

  isClearing() {
    return this.getProvider().isClearing();
  }

  setClearing() {
    this.binding.meta(CLEARING_PATH).set(true);
  }

  resetClearing() {
    this.binding.meta(CLEARING_PATH).remove();
  }

  hasLoaded() {
    return this.getProvider().hasLoaded();
  }

  markLoaded() {
    this.binding.meta(LOADED_PATH).set(true);
  }

  resetLoaded() {
    this.binding.meta(LOADED_PATH).remove();
  }
}
